import isEmpty from 'lodash/isEmpty'

const hasOneOf = items => (
  items.some(item => !isEmpty(item) && item[0].text !== '')
)

export default ({
  copyAlignment,
  subtitle,
  title,
  copy,
  titleForeground
}, {
  colors,
  rhythm
}) => ({
  title: {
    color: colors[titleForeground]
  },

  subtitle: {
    marginTop: rhythm(0.25)
  },

  copy: {
    textAlign: copyAlignment,
    marginTop: hasOneOf([title, subtitle]) && rhythm(1)
  },

  buttons: {
    paddingTop: rhythm(1),
    '&:first-child': {
      paddingTop: 0
    }
  }
})



// WEBPACK FOOTER //
// ./components/ui/Content/styles.js